export default __webpack_public_path__ + "static/media/videos.d807be5d.svg";